

































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import CancelledReason from '@/models/Shared/CancelledReason';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import CancelBookingRoleViewModel from '@/models/BookingRoles/CancelBookingRoleViewModel';
import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';

@Component({
    name: 'BookingRoleCancel'
})
export default class BookingRoleCancel extends GiganautVueDialog {
 
  cancelledReason: CancelledReason = CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED;
  cancelledText = '';
  @Prop({required: true})
	bookingRoleId: string;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.cancelledText = '';
      this.cancelledReason = CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED;
    }
  }

  get cancelledReasons() {
    return ListUtils.cancelledReasonsForBooker();
  }

  get cancellationDisabled () {
    return this.cancelledText !== 'CANCEL'
  }


  async confirm() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const vm = new CancelBookingRoleViewModel()
    vm.updatedAt = BookingDetailsModule.currentBooking.updatedAt;
    vm.bookingRoleId = this.bookingRoleId;
    vm.cancelledReason = this.cancelledReason;
    
    await BookingDetailsModule.cancelBookingRole(vm)
    await BookingDetailsModule.updateOfferedSelectedBookingRole(BookingDetailsModule.selectedBookingRole);
    await BookingDetailsModule.updateBookedSelectedBookingRole(BookingDetailsModule.selectedBookingRole);
    this.dialog = false;
  }
}
